import useGetLoanSummary, {
  type ProductType,
} from '~/common/hooks/useGetLoanSummary';
import { useVAIRRRLCheck } from '~/common/hooks/useVAIRRRLCheck';
import { SUMMARY_CATEGORIES } from '~/pages/Home/constants';

function getCurrentProductType({
  isVAIRRRL,
  loanProductType,
}: {
  isVAIRRRL: boolean;
  loanProductType?: ProductType;
}): Uppercase<ProductType> | 'VAIRRRL' {
  if (isVAIRRRL) return 'VAIRRRL';
  return loanProductType?.toUpperCase() as Uppercase<ProductType>;
}

export type SummaryCategory = (typeof SUMMARY_CATEGORIES)[number];

function getCategoriesForProduct(
  categories: SummaryCategory[] | undefined,
  product: string,
): SummaryCategory[] {
  if (!Array.isArray(categories)) return [];
  return categories.filter((cat) => cat.showForProducts.includes(product));
}

export function useProductAndCategories(categories?: SummaryCategory[]) {
  const isVAIRRRL = useVAIRRRLCheck();
  const { data: loanSummary } = useGetLoanSummary();
  const loanProductType = loanSummary?.loanInfo?.loanProductType;

  // Always use SUMMARY_CATEGORIES if categories is not a non-empty array
  const safeCategories =
    Array.isArray(categories) && categories.length > 0
      ? categories
      : SUMMARY_CATEGORIES;
  const currentProduct = getCurrentProductType({
    isVAIRRRL,
    loanProductType,
  });

  const filteredCategories = getCategoriesForProduct(
    safeCategories,
    currentProduct,
  );
  return { currentProduct, filteredCategories };
}
